<template>
  <div
    class="flex gap-8 justify-between items-center px-4 h-[58px] border-b bg-primary border-secondary"
  >
    <div
      class="w-full h-5 my-1.5 bg-gray-200 rounded-xs animate-pulse"
      :style="'max-width:' + width + '%'"
    />
    <div class="flex gap-2">
      <div class="w-7 h-5 my-1.5 bg-gray-200 rounded-xs animate-pulse" />
      <div class="w-7 h-5 my-1.5 bg-gray-200 rounded-xs animate-pulse" />
      <div class="w-7 h-5 my-1.5 bg-gray-200 rounded-xs animate-pulse" />
      <div class="w-7 h-5 my-1.5 bg-gray-200 rounded-xs animate-pulse" />
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from "vue";

const items = ref([2, 3, 4, 5, 6]);

const width = computed(() => {
  return items.value[Math.floor(Math.random() * items.value.length)] * 10;
});
</script>
